/*
 * Copyright (C) 2021 Quartet Health, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

import * as React from 'react';

export interface Props extends React.DOMAttributes<SVGElement> {
  className?: string;
  style?: object;
}

export default ({ className = '', style = {}, ...restProps }: Props) => (
  <svg
    width="260"
    height="229"
    className={className}
    style={style}
    {...restProps}
  >
    <defs>
      <path
        d="M98.507,196.844 C44.222,196.844 0.085,152.665 0.085,98.422 C0.085,44.136 44.265,0 98.507,0 C152.793,0 196.93,44.18 196.93,98.422 C196.93,152.665 152.793,196.844 98.507,196.844"
        id="path-1"
      ></path>
      <path
        d="M98.507,196.844 C44.222,196.844 0.085,152.665 0.085,98.422 C0.085,44.136 44.265,0 98.507,0 C152.793,0 196.93,44.18 196.93,98.422 C196.93,152.665 152.793,196.844 98.507,196.844"
        id="path-3"
      ></path>
      <path
        d="M98.507,196.844 C44.222,196.844 0.085,152.665 0.085,98.422 C0.085,44.136 44.265,0 98.507,0 C152.793,0 196.93,44.18 196.93,98.422 C196.93,152.665 152.793,196.844 98.507,196.844"
        id="path-5"
      ></path>
    </defs>
    <g id="404" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="Group"
        transform="translate(64.000000, 99.000000)"
        stroke="#17033B"
        strokeWidth="2"
      >
        <path
          d="M9.013,48.2150101 C10.9139878,48.2181923 12.7380345,47.464441 14.0822378,46.1202378 C15.426441,44.7760345 16.1801923,42.9519878 16.1770101,41.051 L16.1770101,7.618 C16.1801923,5.71701224 15.426441,3.89296545 14.0822378,2.54876222 C12.7380345,1.20455898 10.9139878,0.450807738 9.013,0.453989901 C7.11201224,0.450807738 5.28796545,1.20455898 3.94376222,2.54876222 C2.59955898,3.89296545 1.84580774,5.71701224 1.8489899,7.618 L1.8489899,41.051 C1.8489899,44.974 5.047,48.2150101 9.013,48.2150101 L9.013,48.2150101 Z"
          id="Path"
          fill="#D5D7DD"
          fillRule="nonzero"
        ></path>
        <path
          d="M15.623,34.27 L18.523,34.57 M15.196,35.678 L17.371,36.19 M0.57,31.572 L2.446,31.072 M2.488,29.29 L0.825,28.94 M0.527,9.239 L2.275,9.339 M0.143,11.053 L2.275,10.603 M1.209,4.719 L2.957,5.699 M15.452,10.918 L17.328,10.518 M14.215,3.61 L16.006,2.501 M5.644,0.54 L6.326,1.776 M12.893,2.032 L13.661,1.009"
          id="Shape"
          strokeLinecap="round"
        ></path>
      </g>
      <g id="Clipped" transform="translate(27.000000, 16.853000)">
        <mask id="mask-2" fill="white">
          <use xlinkHref="#path-1"></use>
        </mask>
        <g id="a"></g>
        <g id="Group" mask="url(#mask-2)" stroke="#17033B" strokeWidth="2">
          <g transform="translate(48.000000, 90.000000)">
            <path
              d="M9.313,48.72 C11.2139873,48.7234576 13.0381393,47.969961 14.3825302,46.6259454 C15.7269211,45.2819298 16.4809269,43.4579882 16.4780119,41.557 L16.4780119,8.124 C16.4814592,6.22266551 15.7276883,4.3982092 14.3832395,3.05376046 C13.0387908,1.70931173 11.2143345,0.955540843 9.313,0.958988146 C7.41183864,0.955806982 5.58763971,1.70969536 4.24340754,3.05411516 C2.89917538,4.39853496 2.14554162,6.22283911 2.14898815,8.124 L2.14898815,41.557 C2.14580774,43.4579878 2.89955898,45.2820345 4.24376222,46.6262378 C5.58796545,47.970441 7.41201224,48.7241923 9.313,48.7210101 L9.313,48.72 Z"
              id="Path"
              fill="#D5D7DD"
              fillRule="nonzero"
            ></path>
            <path
              d="M15.88,34.776 L18.823,35.076 M15.497,36.226 L17.672,36.738 M0.87,32.09 L2.746,31.578 M2.789,29.788 L1.126,29.488 M0.827,9.744 L2.576,9.894 M0.443,11.609 L2.576,11.109 M1.51,5.224 L3.258,6.204 M15.753,11.473 L17.629,11.023 M14.516,4.115 L16.307,3.006 M5.945,1.045 L6.627,2.325 M13.194,2.58 L13.962,1.514"
              id="Shape"
              fill="none"
              strokeLinecap="round"
            ></path>
          </g>
        </g>
      </g>
      <g id="Clipped" transform="translate(27.000000, 16.853000)">
        <mask id="mask-4" fill="white">
          <use xlinkHref="#path-3"></use>
        </mask>
        <g id="c"></g>
        <circle
          id="Oval"
          stroke="#17033B"
          strokeWidth="2"
          fill="#E3E6EB"
          fillRule="nonzero"
          mask="url(#mask-4)"
          cx="98.507"
          cy="636.247"
          r="516.674"
        ></circle>
      </g>
      <g id="Clipped" transform="translate(27.000000, 16.853000)">
        <mask id="mask-6" fill="white">
          <use xlinkHref="#path-5"></use>
        </mask>
        <g id="e"></g>
        <circle
          id="Oval"
          stroke="#17033B"
          strokeWidth="2"
          fill="#E3E6EB"
          fillRule="nonzero"
          mask="url(#mask-6)"
          cx="45.416"
          cy="25.373"
          r="27.079"
        ></circle>
      </g>
      <g
        id="Group"
        transform="translate(115.000000, 19.000000)"
        stroke="#17033B"
        strokeWidth="2"
      >
        <path
          d="M17.558,80.923 C17.216,80.951 16.87,80.966 16.52,80.966 C9.612,80.966 3.983,75.336 3.983,68.429 L3.983,48.855 C3.983,41.947 9.569,36.318 16.52,36.318 C23.429,36.318 29.058,41.947 29.058,48.855 L29.058,55.849 L42.576,55.849 C49.526,55.849 55.113,61.478 55.113,68.386 C55.113,75.294 49.484,80.923 42.576,80.923 L17.558,80.923 L17.558,80.923 Z M83.087,72.864 L83.087,65.87 C83.087,58.962 88.717,53.333 95.625,53.333 C102.533,53.333 108.162,58.962 108.162,65.87 L108.162,85.443 C108.162,92.352 102.533,97.981 95.625,97.981 C95.275,97.981 94.929,97.966 94.587,97.938 L69.569,97.938 C62.661,97.938 57.032,92.309 57.032,85.401 C57.032,78.493 62.618,72.864 69.569,72.864 L83.087,72.864 L83.087,72.864 Z"
          id="Shape"
          fill="#E3E6EB"
          fillRule="nonzero"
        ></path>
        <path
          d="M56.733,149.452 C69.058,149.452 79.036,139.473 79.036,127.149 L79.036,23.141 C79.036,10.817 69.058,0.838 56.733,0.838 C44.409,0.838 34.431,10.817 34.431,23.141 L34.431,127.149 C34.431,139.473 44.409,149.452 56.733,149.452 Z"
          id="Path"
          fill="#F3F4F7"
          fillRule="nonzero"
        ></path>
        <path
          d="M77.245,106.083 L86.328,106.893 M75.966,110.518 L82.746,112.096 M30.465,97.64 L36.307,96.147 M36.435,90.433 L31.232,89.537 M1.893,65.316 L6.584,64.206 M5.518,60.07 L0.742,59.175 M10.38,40.113 L7.693,36.318 M18.055,38.151 L18.695,34.313 M30.337,28.173 L35.795,28.523 M29.186,33.631 L35.796,32.394 M112,61.392 L106.67,62.672 M111.53,55.806 L105.56,58.919 M32.47,14.058 L37.842,17.171 M88.29,54.186 L90.934,57.981 M76.776,33.29 L82.576,32.139 M108.12,85.486 L111.701,86.083 M72.938,10.646 L78.482,7.192 M46.243,1.051 L48.375,5.017 M68.844,5.785 L71.19,2.586"
          id="Shape"
          strokeLinecap="round"
        ></path>
      </g>
      <path
        d="M194.1,44.25 C202.627549,52.5422453 209.589648,62.3044964 214.652,73.068 M223.331,103.871 C223.726,107.448 223.93,111.083 223.93,114.763 C223.93,169.006 179.793,213.186 125.507,213.186 C71.222,213.186 27.085,169.006 27.085,114.763 C27.085,60.478 71.265,16.341 125.507,16.341 C137.827,16.341 149.624,18.617 160.502,22.769"
        id="Shape"
        stroke="#17033B"
        strokeWidth="2"
      ></path>
    </g>
  </svg>
);
